<ng-container *ngIf="calendarDates$ | async as calendarDates">
  <div
    class="date-wrapper border rounded-medium shadow-small white-bg"
    [class.date-wrapper--return]="showReturnField$ | async"
  >
    <button
      class="date-departure border-right ps-medium-x focus-inset flex flex--column flex--left-center grow fill align-left"
      (click)="openDatepicker()"
      data-testid="destinations-date-field-departure-button"
    >
      <div class="font-body-1 regular-type nordic-blue-900-text">
        {{ 'destinationSearch.datepicker.departureDate' | finLocalization }}
      </div>
      <div class="medium-type font-body-1 nordic-blue-900-text" data-testid="destinations-departure-date-text">
        <ng-container *ngIf="calendarDates.departureDate">{{
          calendarDates.departureDate | finDateFormat: 'DATE'
        }}</ng-container>
        <ng-container *ngIf="!calendarDates.departureDate">{{
          'destinationSearch.datepicker.allDates' | finLocalization
        }}</ng-container>
      </div>
    </button>
    <button
      *ngIf="showReturnField$ | async"
      class="date-return border-left ps-medium-x focus-inset flex flex--column flex--left-center grow fill align-left"
      (click)="openDatepicker()"
      data-testid="destinations-return-button"
    >
      <div class="font-body-1 regular-type nordic-blue-900-text">
        {{ 'destinationSearch.datepicker.returnDate' | finLocalization }}
      </div>
      <div class="medium-type font-body-1 nordic-blue-900-text" data-testid="destinations-return-date-text">
        <ng-container *ngIf="calendarDates.returnDate">{{
          calendarDates.returnDate | finDateFormat: 'DATE'
        }}</ng-container>
        <ng-container *ngIf="!calendarDates.returnDate">{{
          'destinationSearch.datepicker.allDates' | finLocalization
        }}</ng-container>
      </div>
    </button>
    <div *ngIf="showReturnField$ | async" class="date-minus white-bg flex flex--center flex--self-center circle">
      <fcom-icon class="icon-medium nordic-blue-900-text" [name]="SvgLibraryIcon.MINUS"></fcom-icon>
    </div>
  </div>

  <fcom-modal
    [(open)]="datepickerOpen"
    (close)="updateTravelDates(calendarDates)"
    [fitToContent]="true"
    [buttons]="null"
  >
    <fcom-datepicker
      *ngIf="datepickerOpen"
      [uiLabels]="'datepicker' | finLocalization"
      [dateLabels]="'date' | finLocalization"
      [titleAreaConfiguration]="{
        title: 'destinationSearch.datepicker.title' | finLocalization,
      }"
      [isDateRange]="showReturnField$ | async"
      [selectableDatesRange]="selectableDatesRange"
      [selectedDates]="[calendarDates.departureDate, calendarDates.returnDate]"
      (selectedDatesChange)="updateCalendarDates($event)"
      (close)="closeDatepicker()"
      data-testid="destinations-datepicker"
    ></fcom-datepicker>
  </fcom-modal>
</ng-container>
